module.exports = __webpack_public_path__ + "static/media/2a1ae9a5-b6b5-405c-b660-bbdf1b356952.deec157e.woff2";